<div class="p-6">
  <div class="flex flex-wrap items-center justify-between gap-4">
    <div class="flex items-center gap-4">
      <h1 class="pharmacyTitle m-0 text-3xl font-bold">{{ currentPharmacyName() }}</h1>
      <div
        class="inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-semibold"
        [class.statusSuccess]="!isOrdersStopped()"
        [class.bg-gray-200]="isOrdersStopped()"
        [class.text-gray-600]="isOrdersStopped()">
        @if (isOrdersStopped()) {
          <span>{{ isArabic() ? "متوقفة عن الطلب" : "Suspended" }}</span>
        } @else {
          <span>{{ isArabic() ? "نشطة" : "Active" }}</span>
        }
      </div>
    </div>
    <div class="toggleCard inline-flex items-center gap-3 rounded-xl border p-3 shadow-sm">
      <span class="labelColorText text-sm font-medium" i18n="@@stopPharmacyOrders">Stop Pharmacy Orders</span>
      <label class="switch">
        <input type="checkbox" [checked]="isOrdersStopped()" (change)="toggleOrdersStatus($event)" />
        <span class="slider"></span>
      </label>
    </div>
  </div>
  <div class="mt-6 flex gap-8 border-b border-gray-200">
    @for (tab of tabs(); track $index) {
      <button
        type="button"
        (click)="selectTab($index)"
        class="tabItem relative cursor-pointer pb-3 text-lg font-bold transition-colors"
        [class.selected]="$index === activeTabIndex()">
        {{ tab.label }}
      </button>
    }
  </div>
</div>
<div class="px-6">
  @if (activeTabIndex() === 0) {
    <app-ph-details-info-tap
      (isTeleSalesAssigned)="isTeleSalesAssigned($event)"
      (isSuspendedChange)="isOrdersStopped.set($event)" />
  } @else if (activeTabIndex() === 1) {}
</div>
<div class="mt-6 flex justify-end gap-3 px-6">
  @if (!hasTeleSalesEmployee()) {
    <div class="w-fit">
      <app-submit-button [type]="'primary'" (click)="openAssignModal()">{{ assignButtonText }}</app-submit-button>
    </div>
  }
  @if (hasTeleSalesEmployee()) {
    <div class="w-fit">
      <app-submit-button [type]="'primary'" (click)="openReassignModal()">{{ reassignButtonText }}</app-submit-button>
    </div>
  }
</div>
@if (showSuspendDialog()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="suspendDialogTitle()"
    [description]="suspendDialogDescription()"
    [itemName]="currentPharmacyName()"
    [confirmContent]="suspendDialogConfirmContent()"
    [cancelContent]="suspendDialogCancelContent()"
    [isLoading]="suspendLoading()"
    [error]="suspendError()"
    (onCancel)="closeSuspendDialog()"
    (onSubmit)="onSuspendDialogSubmit()" />
}
@if (showSuccess()) {
  <app-successful-notification type="success" [title]="successMessage()" />
}
